// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".audio-viewer{padding:80px;padding-bottom:140px}", "",{"version":3,"sources":["webpack://./client/modules/file-viewer/viewer-audio/viewer-audio.scss"],"names":[],"mappings":"AACA,cACE,YAAA,CACA,oBAAA","sourcesContent":["@import \"~@/styles/index.scss\";\n.audio-viewer {\n  padding: 80px;\n  padding-bottom: 140px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
